var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingLogsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.75C0 1.23122 1.23122 0 2.75 0H13.25C14.7688 0 16 1.23122 16 2.75V10.25C16 11.7688 14.7688 13 13.25 13H9.02478L11.6431 14.6113C11.9958 14.8283 12.1058 15.2903 11.8887 15.6431C11.6717 15.9958 11.2097 16.1058 10.8569 15.8887L8 14.1306L5.14307 15.8887C4.7903 16.1058 4.32834 15.9958 4.11126 15.6431C3.89417 15.2903 4.00416 14.8283 4.35693 14.6113L6.97522 13H2.75C1.23122 13 0 11.7688 0 10.25V2.75ZM2.75 1.5C2.05964 1.5 1.5 2.05964 1.5 2.75V10.25C1.5 10.9404 2.05964 11.5 2.75 11.5H13.25C13.9404 11.5 14.5 10.9404 14.5 10.25V2.75C14.5 2.05964 13.9404 1.5 13.25 1.5H2.75Z",
    fill: "#9E9FA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingLogsIcon);
export default __webpack_public_path__ + "static/media/trainingLogsIcon.dc1ed8906fb3771dd7f74bbe2bf62594.svg";
export { ForwardRef as ReactComponent };